/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Height_HelpInputs */



/**
* | output |
* | --- |
* | "Number of lines down the screen (1-50)" |
*
* @param {Options_Display_Height_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_height_help = /** @type {((inputs?: Options_Display_Height_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Height_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de lignes sur l'écran (1-50)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Zeilen auf dem Bildschirm (1-50)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di linee sullo schermo (1-50)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество строк на экране (от 1 до 50)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de líneas en la pantalla (1-50)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕上方的行数（1-50）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面の行数（1～50）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन पर नीचे की ओर जाने वाली पंक्तियों की संख्या (1-50)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de linhas na tela (1-50)")
	return /** @type {LocalizedString} */ ("Number of lines down the screen (1-50)")
});